// extracted by mini-css-extract-plugin
export default {"QCardContainer":"QuestionCard_QCardContainer__BqXQm","Cross":"QuestionCard_Cross__jrQJr","Edit":"QuestionCard_Edit__e+iSB","CardGroup":"QuestionCard_CardGroup__IC3pR"};